import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Backdrop, Box, Button, CircularProgress, Dialog, DialogContent, DialogContentText, FormLabel, FormGroup, Checkbox, DialogTitle, FormControl, FormControlLabel, Autocomplete, Grid, MenuItem, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from "yup";
import Error from '../../../components/error/error';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
import pdfIcon from "../../../images/pdfIcon.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { cfpBaseUrl } from '../../../network/urls';
import { companyShortName, dBillAPI, getMeterType, getPhase, handleFileUpload, isImage, isPdf, subDivAPI, subdivisionName } from '../../../services/Functions';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import '../NewConnection/NewConnectionForm.scss';
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import { useSelector } from 'react-redux';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';
let initialValues = {
  iv_application_type: null,
  iv_consumer_id: '',
  iv_reference_number: '',

  iv_connection_type: "",
  iv_tariff_description: '',
  iv_tariff_code: '',

  iv_applicant_name: '',
  iv_father_name: '',
  iv_applicant_cnic: '',
  iv_applicant_phone_no: '',
  iv_applicant_email: '',

  iv_new_name: "",
  iv_new_cnic: "",
  iv_new_email: "",
  iv_new_phone_no: "",
  iv_new_father_name: '',
  iv_relation_type: "",
  iv_load_type: "",
  iv_new_load: "",
  iv_ntn_num: '',

  iv_new_tariff: "",

  iv_applicant_cnic_front: "",
  iv_applicant_cnic_back: "",
  iv_ownership_document: "",
  iv_electricity_bill_document: "",
  iv_fbr_document: "",
  iv_authority_letter: "",

  iv_previous_owner_cnic_front: '',
  iv_previous_owner_cnic_back: '',
  iv_noc_from_previous_owner: '',
  iv_new_owner_affidavite: "",
  iv_additional_civic_document: '',
  iv_any_other_document: '',
  iv_consent_image_change_of_name: '',

  iv_test_report: "",

  iv_other_documents: "",
  iv_meter_type: '',
  iv_phase: '',
  iv_applicant_address: '',
  iv_telco: ''
};

const ChangeOfAttributesForm = () => {

  const { sourcePage } = useParams();
  const { token, name: userName, roleName, userId, code: userCode } = useSelector((state) => state.auth)
  let userCompany = userCode.slice(0, 2);
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const getLogo = (code) => {
    switch (code) {
      case '10':
        return pitcLogo
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '26':
        return PESCOLOGO
      case '27':
        return HAZECOLOGO
      case '37':
        return HESCOLOGO
      case '38':
        return SEPCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      default:
        return MEPCOLOGO
    }
  }
  const [coaStatusBarArray, setCoaStatusBarArray] = useState([{
    title1: 'APPLICATION',
    title2: 'DETAIL',
    status: 0
  },
  {
    title1: `APPLICANT'S`,
    title2: 'CNIC',
    status: 0
  },
  {
    title1: 'PROOF OF',
    title2: 'OWNERSHIP',
    status: 0
  },
  {
    title1: 'ELECTRICITY',
    title2: `NAME`,
    status: 0
  },
  {
    title1: 'FBR',
    title2: `NAME`,
    status: 0
  }
    // {
    //   title1: 'AFFIDAVIT',
    //   title2: 'APPLICANT',
    //   status: 0
    // },
    // {
    //   title1: 'ADDITIONAL CIVIC',
    //   title2: 'AUTHORITY DOCUMENT',
    //   status: 0
    // },
    // {
    //   title1: 'ANY OTHER',
    //   title2: 'DOCUMENT',
    //   status: 0
    // },
    // {
    //   title1: 'CONSENT ',
    //   title2: 'DOCUMENT',
    //   status: 0
    // }
  ]);

  let navigate = useNavigate()
  //Defining all the states tobe used in page
  const [name, setName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [cnicNo, setCnicNo] = useState('');
  const [email, setEmail] = useState('');
  const [sectionedLoad, setSectionedLoad] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [areaType, setAreaType] = useState('');
  const [referenceNumberForAPI, setReferenceNumberForAPI] = useState('');
  const [sanctionedType, setSanctionedType] = React.useState('');
  const [oldTariff, setOldTariff] = React.useState('');
  const [oldFatherName, setOldFatherName] = React.useState('');
  const [newTarif, setNewTarif] = React.useState('');
  const [tarifData, setTarifData] = React.useState([]);
  const [termCondition, setTermCondition] = useState('yes');
  const [isLoadingSpinner, setIsLoadingSpinner] = React.useState(false);
  const [pageTitle, setPageTitle] = useState('Change of Attributes Form')
  const [viewBackdrop, setViewBackdrop] = useState(false);

  const [applicationID, setApplicationID] = useState('');
  const [consumerID, setConsumerID] = useState('');
  const [lookUpDataOfCON, setLookUpDataOfCON] = useState(null);


  const [applicantCnicFront, setApplicantCnicDocumentFront] = useState('');
  const [applicantCnicFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState('');
  const [applicantCnicBack, setApplicantCnicDocumentBack] = useState('');
  const [applicantCnicBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState('');
  const [ownerShip, setOwnerShip] = useState('');
  const [electricityBill, setElectricityBill] = useState('');
  const [fbrDocument, setFbrDocument] = useState('');

  const [ownerShipThumbnail, setOwnerShipThumbnail] = useState('');
  const [electricityBillThumbnail, setElectricityBillThumbnail] = useState('');
  const [fbrThumbnail, setFbrThumbnail] = useState('');

  const [authorityLetter, setAuthorityLetter] = useState('');
  const [authorityLetterThumbnail, setAuthorityLetterThumbnail] = useState('');
  const [cnicPreviousOwnerFront, setCnicPreviousOwnerFront] = useState('');
  const [cnicPreviousOwnerFrontThumbnail, setCnicPreviousOwnerFrontThumbnail] = useState('');
  const [cnicPreviousOwnerBack, setCnicPreviousOwnerBack] = useState('');
  const [cnicPreviousOwnerBackThumbnail, setCnicPreviousOwnerBackThumbnail] = useState('');
  const [nocPreviousOwner, setNocPreviousOwner] = useState('');
  const [nocPreviousOwnerThumbnail, setNocPreviousOwnerThumbnail] = useState('');
  const [affidaviteApplicant, setAffidaviteApplicant] = useState('');
  const [affidaviteApplicantThumbnail, setAffidaviteApplicantThumbnail] = useState('');
  const [additionalCivicDocument, setAdditionalCivicDocument] = useState('');
  const [anyOtherDocument, setAnyOtherDocument] = useState('');
  const [consentImageChangeOfNameDocument, setConsentImageChangeOfNameDocument] = useState('');
  const [additionalCivicDocumentThumbnail, setAdditionalCivicDocumentThumbnail] = useState('');
  const [anyOtherDocumentThumbnail, setAnyOtherDocumentThumbnail] = useState('');
  const [consentImageChangeOfNameDocumentThumbnail, setConsentImageChangeOfNameDocumentThumbnail] = useState('');
  const [otherDocuments, setOtherDocuments] = useState('');
  const [otherDocumentsThumbnail, setOtherDocumentsThumbnail] = useState('');
  const [checked, setChecked] = useState(false);
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState('')
  const [applicantCnicBackError, setApplicantCnicBackError] = useState('')
  const [ownerShipError, setOwnerShipError] = useState("");
  const [electricityBillError, setElectricityBillError] = useState("");
  const [fbrError, setFbrError] = useState("");

  const [authorityLetterError, setAuthorityLetterError] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [cnicPreviousOwnerFrontError, setCnicPreviousOwnerFrontError] = useState('')
  const [cnicPreviousOwnerBackError, setCnicPreviousOwnerBackError] = useState('')
  const [nocPreviousOwnerError, setNocPreviousOwnerError] = useState("");
  const [affidaviteApplicantError, setAffidaviteApplicantError] = useState("");
  const [additionalCivicDocumentError, setAdditionalCivicDocumentError] = useState("");
  const [anyOtherDocumentError, setAnyOtherDocumentError] = useState("");
  const [consentImageChangeOfNameDocumentError, setConsentImageChangeOfNameDocumentError] = useState("");
  const [otherDocumentsError, setOtherDocumentsError] = useState("");

  const [error, setError] = useState('')

  const [changeOfNamePopUp, setChangeOfNamePopUp] = useState(false)
  const [changeOfLoadPopUp, setChangeOfLoadPopUp] = useState(false)
  const [changeOfTariffPopUp, setChangeOfTariffPopUp] = useState(false)

  const [searchBy, setSearchBy] = useState('referenceNo');
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [loadChangeType, setLoadChangeType] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({
    name: false,
    load: false,
    tariff: false,
  });
  const [connectionDate, setConnectionDate] = useState('');


  const handleLoadChangeType = (e) => {
    const selectedTypeId = parseInt(e.target.value);
    values.iv_load_type = selectedTypeId
    console.log("Selected Load Change Type (typeId):", selectedTypeId);
  };
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
  //Defining Functions to set values in states
  const Name = event => {
    setName(event.target.value);
  };
  const PhoneNo = event => {
    event.preventDefault();
    setPhoneNo(event.target.value);
  };
  const CnicNo = event => {
    setCnicNo(event.target.value);
  };

  const Email = event => {
    setEmail(event.target.value);
  };

  const FatherName = event => {
    setOldFatherName(event.target.value);
  };

  const SectionedLoad = event => {
    setSectionedLoad(event.target.value);
  };

  const SanctionedType = (event) => {
    handleChange(event)
    setSanctionedType(event.target.value)
  };

  const TarifData = (event) => {
    handleChange(event)
    setNewTarif(event.target.value);
  };

  const OldTariff = (event) => {
    setOldTariff(event.target.value)
  };

  const ApplicantCnicDocumentFront = (event) => {
    const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
  };

  const ApplicantCnicDocumentBack = (event) => {
    const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
  };

  const OwnerShip = (event) => {
    const newFileName = 'ownership.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setOwnerShip, setOwnerShipError, setOwnerShipThumbnail, newFileName);
  };

  const ApplicantElectricityBill = (event) => {
    const newFileName = 'electricityBill.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setElectricityBill, setElectricityBillError, setElectricityBillThumbnail, newFileName);
  };

  const ApplicantFbr = (event) => {
    const newFileName = 'fbrDoc.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setFbrDocument, setFbrError, setFbrThumbnail, newFileName);
  };

  const ApplicantAnyOtherDocument = (event) => {
    const newFileName = 'anyOtherDocument.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAnyOtherDocument, setAnyOtherDocumentError, setAnyOtherDocumentThumbnail, newFileName);
  };

  const AuthorityLetter = (event) => {
    const newFileName = 'authorityLetter.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAuthorityLetter, setAuthorityLetterError, setAuthorityLetterThumbnail, newFileName);
  };

  const PreviousOwnerCNICFront = (event) => {
    const newFileName = 'previousOwnerCNICFront.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setCnicPreviousOwnerFront, setCnicPreviousOwnerFrontError, setCnicPreviousOwnerFrontThumbnail, newFileName);
  };

  const PreviousOwnerCNICBack = (event) => {
    const newFileName = 'previousOwnerCNICBack.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setCnicPreviousOwnerBack, setCnicPreviousOwnerBackError, setCnicPreviousOwnerBackThumbnail, newFileName);
  };

  const NocPreviousOwner = (event) => {
    const newFileName = 'nocPreviousOwner.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setNocPreviousOwner, setNocPreviousOwnerError, setNocPreviousOwnerThumbnail, newFileName);
  };

  const AffidaviteApplicant = (event) => {
    const newFileName = 'affidaviteApplicant.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAffidaviteApplicant, setAffidaviteApplicantError, setAffidaviteApplicantThumbnail, newFileName);
  };

  const AdditionalCivicDocument = (event) => {
    const newFileName = 'additionalCivicDocument.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAdditionalCivicDocument, setAdditionalCivicDocumentError, setAdditionalCivicDocumentThumbnail, newFileName);
  };

  const AnyOtherDocument = (event) => {
    console.log(event);
    const newFileName = 'anyOtherDocument.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAnyOtherDocument, setAnyOtherDocumentError, setAnyOtherDocumentThumbnail, newFileName);
  };

  const OtherDocuments = (event) => {
    const newFileName = 'otherDocuments.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setOtherDocuments, setOtherDocumentsError, setOtherDocumentsThumbnail, newFileName);
  };
  const ConsentImageOfChangeOfNameDocuments = (event) => {
    const newFileName = 'consentImageChangeOfName.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setConsentImageChangeOfNameDocument, setConsentImageChangeOfNameDocumentError, setConsentImageChangeOfNameDocumentThumbnail, newFileName);
  };

  const errorCloses = () => {
    setError('')
  }

  const handleChangeApplyChangeOfName = () => {
    setChecked(!checked);
  };

  const printApplicationReceipt = (values, applicationID, userName, applicationTypeName, roleName, referenceNumber) => {
    console.log(values, "values in Reciept.")
    let DiscoCode = values.iv_sub_divison.toString().slice(0, 2);
    const doc = new jsPDF({ compressPdf: true });

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ['12', '13', '11', '16', '26', '27', '48', '59'];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(getLogo(DiscoCode), "PNG", logoX, height, logoWidth, logoHeight); // Adjust the position and size of the logo image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of " + applicationTypeName,
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(referenceNumber.toString().slice(2, 4)),
      padding,
      height
    );
    doc.text(
      referenceNumber.toString().slice(2, 7) +
      " / " +
      subdivisionName(parseInt(referenceNumber.toString().slice(2, 7)), subDivisionsArray),
      padding + leftMargin,
      height
    );


    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;

    doc.text("Issued By:", padding, height);
    doc.text("Designation:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");

    increment = 10;
    height = height + increment;

    leftMargin = 120;

    doc.text(
      userName,
      padding,
      height
    );

    doc.text(
      roleName,
      padding + leftMargin,
      height
    );


    increment = 10;
    height = height + increment;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);

    doc.text("Applicant Details", doc.internal.pageSize.getWidth() / 2, height, {
      align: "center",
    });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");


    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Application Date: ", padding + leftMargin, height);
    doc.setFont("helvetica", "normal");
    leftMargin = 150;
    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();
    doc.text(formattedDate, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No.: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNumber, padding + leftMargin, height);

    leftMargin = 100;
    doc.setFont("helvetica", "bold");
    doc.text("Mobile No.: ", padding + leftMargin, height);
    leftMargin = 150;
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_applicant_phone_no, padding + leftMargin, height);




    if (applicationTypeName.includes("Name")) {

      increment = 10;
      height = height + increment;

      const leftMarginOld = 40;
      const leftMarginNewLabel = 100;
      const leftMarginNew = 150;

      doc.setFont("helvetica", "bold");
      doc.text("Old Name:", padding, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_applicant_name, padding + leftMarginOld, height);

      doc.setFont("helvetica", "bold");
      doc.text("New Name:", padding + leftMarginNewLabel, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_new_name, padding + leftMarginNew, height);

      // ----------------------------------------------------
      increment = 10;
      height = height + increment;

      doc.setFont("helvetica", "bold");
      doc.text("Old CNIC:", padding, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_applicant_cnic, padding + leftMarginOld, height);

      doc.setFont("helvetica", "bold");
      doc.text("New CNIC:", padding + leftMarginNewLabel, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_new_cnic, padding + leftMarginNew, height);

      // ----------------------------------------------------
      increment = 10;
      height = height + increment;

      doc.setFont("helvetica", "bold");
      doc.text("Old F. Name:", padding, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_father_name, padding + leftMarginOld, height);

      doc.setFont("helvetica", "bold");
      doc.text("New F. Name:", padding + leftMarginNewLabel, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_new_father_name, padding + leftMarginNew, height);

    }

    if (applicationTypeName.includes("Load")) {

      increment = 10;
      height = height + increment;

      const leftMarginOld = 40;
      const leftMarginNewLabel = 100;
      const leftMarginNew = 150;

      doc.setFont("helvetica", "bold");
      doc.text("Old Load:", padding, height);
      doc.setFont("helvetica", "normal");
      doc.text(sectionedLoad, padding + leftMarginOld, height);

      doc.setFont("helvetica", "bold");
      doc.text("New Load:", padding + leftMarginNewLabel, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_new_load, padding + leftMarginNew, height);

      // ----------------------------------------------------

    }

    if (applicationTypeName.includes("Tariff")) {

      increment = 10;
      height = height + increment;

      const leftMarginOld = 40;
      const leftMarginNewLabel = 100;
      const leftMarginNew = 150;

      doc.setFont("helvetica", "bold");
      doc.text("Old Tariff:", padding, height);
      doc.setFont("helvetica", "normal");
      doc.text(oldTariff, padding + leftMarginOld, height);

      doc.setFont("helvetica", "bold");
      doc.text("New Tariff:", padding + leftMarginNewLabel, height);
      doc.setFont("helvetica", "normal");
      doc.text(values.iv_new_tariff, padding + leftMarginNew, height);

      // ----------------------------------------------------

    }

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight()
      );
    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = (applicationType) => {
    setChangeOfNamePopUp(false);
    setChangeOfLoadPopUp(false);
    setChangeOfTariffPopUp(false);
    if (applicationType === 'CON') {
      navigate('/change-of-attributes-table');
    } else if (applicationType === 'COL') {
      navigate('/change-of-load-table');
    } else if (applicationType === 'COT') {
      navigate('/change-of-tariff-table');
    }
  };

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setSubDivision('')
    values.iv_consumer_id = ''
    values.iv_reference_number = ''

    values.iv_applicant_name = ''
    values.iv_father_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_address = ''

    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_new_name = ""
    values.iv_new_cnic = ""
    values.iv_new_email = ""
    values.iv_new_phone_no = ""
    values.iv_new_father_name = ''
    values.iv_load_type = ""
    values.iv_new_load = ""
    values.iv_new_tariff = ""
    values.iv_applicant_cnic_front = ""
    values.iv_applicant_cnic_back = ""
    values.iv_ownership_document = ""
    values.iv_previous_owner_cnic_front = ''
    values.iv_load_type = ""
    values.iv_application_type = ""
    values.iv_relation_type = ""
    values.iv_previous_owner_cnic_back = ''
    values.iv_noc_from_previous_owner = ''
    values.iv_new_owner_affidavite = ""
    values.iv_additional_civic_document = ''
    values.iv_any_other_document = ""
    values.iv_test_report = ""
    values.iv_other_documents = ""
    values.name = ''
    values.phoneNo = ''
    values.email = ''
    values.oldFatherName = ''
    setName()
    setOldFatherName()
    setPhoneNo()
    setEmail()
    values.iv_name = ''
    values.iv_cnic = ''
    values.iv_applicant_address = ''
    values.iv_connection_type = ''
    values.iv_tariff_description = ''
    values.iv_tariff_code = ''
    values.iv_applicant_name = ''
    values.iv_father_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_address = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_meter_type = ''
    values.iv_phase = ''
    setSectionedLoad('')
    setChecked(false)
  };

  const getChangeOfText = (options) => {
    // 1. Convert true values into an array of capitalized titles
    const selected = Object.keys(options)
      .filter(key => options[key])
      .map(key => key.charAt(0).toUpperCase() + key.slice(1));

    // 2. Build final text
    if (selected.length === 1) {
      return `Change of ${selected[0]}`;
    }

    if (selected.length === 2) {
      return `Change of ${selected[0]} and ${selected[1]}`;
    }

    // 3 or more
    return `Change of ${selected.slice(0, -1).join(", ")} and ${selected[selected.length - 1]}`;
  };


  function parseConnectionDate(dateStr) {
    if (!dateStr) return null; // handle empty/null
    const months = {
      JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5,
      JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11
    };

    const parts = dateStr.trim().split(/\s+/); // split by any spaces
    if (parts.length !== 3) return null;

    const [dayStr, monthStr, yearStr] = parts;
    const dayNum = parseInt(dayStr, 10);
    const monthNum = months[monthStr.toUpperCase()];
    const yearNum = 2000 + parseInt(yearStr, 10);

    if (isNaN(dayNum) || monthNum === undefined || isNaN(yearNum)) return null;

    return new Date(yearNum, monthNum, dayNum);
  }



  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
        otherwise: Yup.string().optional()
      }),
      iv_new_name: Yup.string().when("iv_application_type", {
        is: (val) => [1, 4, 5, 6].includes(val),
        then: (schema) => schema.required("Enter new name."),
        otherwise: (schema) => schema.optional(),
      }),
      iv_telco: Yup.string()
        .required("Please select a Telco.")
        .notOneOf(["", null, undefined], "Please select a Telco."),
      iv_new_cnic: Yup.string().when("iv_application_type", {
        is: (val) => [1, 4, 5, 6].includes(val),
        then: (schema) => schema.required("Enter new CNIC."),
        otherwise: (schema) => schema.optional(),
      }),

      iv_application_type: Yup.number()
        .required("Please select at least one change: Name, Load, or Tariff.")
        .oneOf([1, 2, 3, 4, 5, 6, 7], "Invalid selection"),

      iv_applicant_phone_no: Yup.string()
        .required("Phone number is required")
        .matches(/^03[0-9]{9}$/, "Phone number must start with 03 and be 11 digits long"),

      iv_new_father_name: Yup.string().when(
        ["iv_application_type", "iv_relation_type"],
        (iv_application_type, iv_relation_type, schema) => {
          if ([1, 4, 5, 6].includes(iv_application_type)) {
            let relationLabel = "";

            if ([1, 2].includes(iv_relation_type)) relationLabel = "father's";
            else if (iv_relation_type === 3) relationLabel = "husband's";
            else if (iv_relation_type === 4) relationLabel = "care of's";

            return schema.required(`Enter ${relationLabel} new name.`);
          }
          return schema.optional();
        }
      ),


      iv_new_email: Yup.string().when("iv_application_type", {
        is: (val) => [1, 2, 3, 4, 5, 6, 7].includes(val),
        then: Yup.string().email("Enter email as 'john@gmail.com'."),
        otherwise: Yup.string().optional(),
      }),

      iv_new_load: Yup.number().when("iv_application_type", {
        is: (val) => [2, 4, 5, 7].includes(val),
        then: (schema) =>
          schema
            .typeError("Enter new load in numbers!")
            .required("New load is required!"),
        otherwise: (schema) => schema.optional(),
      }),
      iv_load_type: Yup.number().when("iv_application_type", {
        is: (val) => [2, 4, 5, 7].includes(val),
        then: (schema) =>
          schema
            .typeError("Select load change type!")
            .required("Load change type is required!"),
        otherwise: (schema) => schema.optional(),
      }),
      iv_relation_type: Yup.number().when("iv_application_type", {
        is: (val) => [1, 4, 5, 6].includes(val),
        then: (schema) =>
          schema
            .typeError("Select relation type!")
            .required("Relation type is required!"),
        otherwise: (schema) => schema.optional(),
      }),

      iv_new_tariff: Yup.string().when("iv_application_type", {
        is: (val) => [3, 4, 6, 7].includes(val),
        then: (schema) =>
          schema
            .required("Select new tariff.")
            .test(
              "not-empty",
              "Select new tariff.",
              (value) => value && value.trim() !== ""
            ),
        otherwise: (schema) => schema.optional(),
      }),

      iv_ntn_num: Yup.string().when('iv_new_tariff', {
        is: (val) => {
          if (!val) return false;
          const cleaned = val.replace('-', ''); // 🔹 remove dash if present (e.g., "A-2" → "A2")
          return cleaned.startsWith('A2') || cleaned.startsWith('B');
        },
        then: (schema) =>
          schema
            .required('NTN No. is required')
            .matches(/^\d+$/, 'NTN must contain only numbers')
            .max(13, 'NTN must be at most 13 digits'),
        otherwise: (schema) => schema.notRequired(),
      }),


      iv_applicant_cnic_front: Yup.mixed().required('Applicant CNIC Front is required'),
      iv_applicant_cnic_back: Yup.mixed().required('Applicant CNIC Back is required'),
      iv_ownership_document: Yup.mixed().required("Ownership proof is required"),
      iv_electricity_bill_document: Yup.mixed().required("Electricity Bill is required"),
      // iv_any_other_document: Yup.mixed().required("An Bill is required"),

      iv_fbr_document: Yup.mixed().when('iv_new_tariff', {
        is: (val) => {
          if (!val) return false;
          const cleaned = val.replace('-', ''); // 🔹 remove any dash
          return cleaned.startsWith('A2') || cleaned.startsWith('B');
        },
        then: (schema) => schema.required('FBR Doc. is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    }),
    onSubmit: async (values, { resetForm }) => {
      console.log(anyOtherDocumentThumbnail, "Any other document");
      console.log(consentImageChangeOfNameDocumentThumbnail, "Consent image");
      console.log('Form values:', values);

      setViewBackdrop(true);
      setIsLoadingSpinner(true);

      // File validations
      if (!applicantCnicFrontThumbnail) {
        setApplicantCnicFrontError('Upload Applicant CNIC front document in JPG, PNG or PDF.');
      } else if (!applicantCnicBackThumbnail) {
        setApplicantCnicBackError('Upload Applicant CNIC back document in JPG, PNG or PDF.');
      } else if (!ownerShipThumbnail) {
        setOwnerShipError('Upload Ownership document in JPG, PNG or PDF.');
      } else if (!electricityBillThumbnail) {
        setElectricityBillError('Upload Electricity Bill in JPG, PNG or PDF.');
      } if (
        oldTariff?.replace('-', '').charAt(0) === 'D' &&
        values.iv_new_tariff?.replace('-', '').charAt(0) === 'B'
      ) {

        console.log("Checking connection date for D to B tariff change:", connectionDate);
        const connectionDateObj = parseConnectionDate(connectionDate);

        if (!connectionDateObj || isNaN(connectionDateObj)) {
          console.log("Invalid connection date:", connectionDate);
          setError("Invalid connection date.");
          setIsLoadingSpinner(false);
          setViewBackdrop(false);
          return;
        }
        
        const today = new Date();
        const diffMs = today - connectionDateObj;
        const diffYears = diffMs / (1000 * 60 * 60 * 24 * 365);
        
        if (diffYears >= 1) {
          apiCalling(values)
          console.log("Connection is ≥ 1 year old. Tariff change D → B allowed.");
          // Call API here
        } else {
          console.log("Connection is < 1 year old. Tariff change D → B not allowed.");
          setError("Connection must be at least 1 year old to move from D to B.");
          setIsLoadingSpinner(false);
          setViewBackdrop(false);
        }
      }
      else {
        apiCalling(values)
      }

      // setIsLoadingSpinner(false);
      // setViewBackdrop(false);
    }
  })


  const apiCalling = async (values) => {
    setViewBackdrop(true);
    const currentOwnerName = [
      values.iv_applicant_name?.trim(),
      values.iv_father_name?.trim()
    ]
      .filter(Boolean) // Remove empty, null, undefined
      .join(' ');
    // const currentOwnerName = `${values.iv_applicant_name} ${values.iv_father_name}`;

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    // Build request payload
    const raw = {
      areaType: areaType,
      referenceNumber,
      customerId: consumerID,
      applicationProgressId: 1,
      submittedThrough: portalName,
      remarks: "Application Submitted.",
      changeOfAttributesType: values.iv_application_type,
      connectionType: values.iv_connection_type,
      currentOwnerName,
      currentOwnerCNIC: values.iv_applicant_cnic || "",
      currentOwnerPhoneNo: values.iv_applicant_phone_no || "",
      currentOwnerEmail: values.iv_applicant_email || "",
      consumerAddress: values.iv_applicant_address || "",
      telcoCode: values.iv_telco,
      changeOfLoadType: values.iv_load_type || "",
      currentSanctionLoad: sectionedLoad || "",
      newSanctionLoad: values.iv_new_load || "",

      // Tariff info
      currentTariff: oldTariff || "",
      newTariff: values.iv_new_tariff || "",

      // Documents
      applicantCNICFront: applicantCnicFrontThumbnail || "",
      applicantCNICBack: applicantCnicBackThumbnail || "",
      electricityBill: electricityBillThumbnail || "",
      ownershipImage: ownerShipThumbnail || "",
      fbrDocument: fbrThumbnail || "",
      ntnNo: values.iv_ntn_num,
      anyOtherDocument : anyOtherDocumentThumbnail || "",
      ...([1, 4, 5, 6].includes(Number(values.iv_application_type))
        ? {
          applicantName: values.iv_new_name || "",
          applicantGuardianType: values.iv_relation_type || "",
          applicantGuardianName: values.iv_new_father_name || "",
          applicantCNIC: values.iv_new_cnic || "",
          applicantPhoneNo: values.iv_applicant_phone_no || "",
          applicantEmail: values.iv_new_email || "",
        }
        : {
          applicantName: values.iv_applicant_name || "",
          applicantGuardianType: values.iv_relation_type || "",
          applicantGuardianName: values.iv_father_name || "",
          applicantCNIC: values.iv_applicant_cnic || "",
          applicantPhoneNo: values.iv_applicant_phone_no || "",
          applicantEmail: values.iv_applicant_email || "",
        }
      ),
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/registerChangeOfAttributes",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(raw),
          redirect: "follow",
        }
      );

      const result = await response.json();

      if (result.status === '200') {
        const applicationID = result.applicationId;
        setViewBackdrop(false);

        setApplicationID(applicationID);

        setName('');
        setCnicNo('');
        setPhoneNo('');
        setEmail('');
        setSectionedLoad('');
        setOldTariff('');
        setOldFatherName('');
        setApplicantCnicDocumentFront('');
        setApplicantCnicDocumentBack('');
        setOwnerShip('');
        setElectricityBill('');
        values.iv_load_type = ""
        values.iv_application_type = ""
        values.iv_relation_type = ""
        setLoadChangeType('');
        setApplicantCnicDocumentFrontThumbnail('');
        setApplicantCnicDocumentBackThumbnail('');
        setOwnerShipThumbnail('');
        setElectricityBillThumbnail('');
        setAnyOtherDocument('');
        setAnyOtherDocumentThumbnail('');
        setFbrDocument('');
        setFbrThumbnail('');

        // Print receipt and show popup
        printApplicationReceipt(
          values,
          applicationID,
          userName,
          getChangeOfText(selectedOptions),
          roleName,
          referenceNumber
        );
        setChangeOfNamePopUp(true);
      } else {
        setViewBackdrop(false);
        setIsLoadingSpinner(false);
        setError(result.message);
      }
    } catch (error) {
      console.error(error);
      setViewBackdrop(false);
      setIsLoadingSpinner(false);
      setError("Something went wrong while submitting the form.");
    }
  }
  // Defining function to fetch current information on behalf of reference number

  const refrenceapi = async () => {
    if (searchBy === 'consumerId') {
      if (!values.iv_consumer_id) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_consumer_id)
      if (apiResponse.basicInfo) {
        const basicInfo = apiResponse.basicInfo;
        setError('');
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_father_name = basicInfo.consumerFName
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_address = `${(basicInfo.consumerAddress1 || '').trim()} ${(basicInfo.consumerAddress2 || '').trim()}`.trim();
        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_name = basicInfo.consumerName
        // values.iv_applicant_address = basicInfo.consumerAddress1 + " " + basicInfo.consumerAddress2
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_subdivision = basicInfo.subDivName
        values.iv_cnic = basicInfo.owner_cnic
        setConsumerID(basicInfo.appNo)
        setConnectionDate(basicInfo.connDate)
        setName(basicInfo.consumerName)
        setCnicNo(basicInfo.owner_cnic ? basicInfo.owner_cnic : '0000000000000');
        setPhoneNo(basicInfo.consumerContactNo ? basicInfo.consumerContactNo : '03000000000');
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setAreaType(basicInfo.refNo.replace(/ /g, "").slice(-1));
        setReferenceNumberForAPI(basicInfo.refNo.replace(/ /g, ""))
        setEmail(basicInfo.consumerEmail ? basicInfo.consumerEmail : 'example@gmail.com');
        setSectionedLoad(basicInfo.sactionLoad);
        setOldTariff(basicInfo.tariffDescription);
        setOldFatherName(basicInfo.consumerFName);
        setIsDataLoaded(true);
      }
      else {
        setError('Customer ID. does not exist!')
        setIsDataLoaded(false);
      }
      setViewBackdrop(false)
    }
    if (searchBy === 'referenceNo') {
      if (!values.iv_reference_number) return;
      setViewBackdrop(true)
      let apiResponse = await dBillAPI(token, values.iv_reference_number)
      if (apiResponse.basicInfo) {
        const basicInfo = apiResponse.basicInfo;
        setError('');
        values.iv_applicant_name = basicInfo.consumerName
        values.iv_father_name = basicInfo.consumerFName
        values.iv_meter_type = getMeterType(basicInfo.conn_catg, basicInfo.meterType, basicInfo.phase, apiResponse.metersInfo.length)
        values.iv_phase = getPhase(basicInfo.sactionLoad)
        values.iv_applicant_cnic = basicInfo.owner_cnic
        values.iv_applicant_address = `${(basicInfo.consumerAddress1 || '').trim()} ${(basicInfo.consumerAddress2 || '').trim()}`.trim();

        values.iv_applicant_phone_no = basicInfo.consumerContactNo
        values.iv_applicant_email = basicInfo.consumerEmail
        values.iv_name = basicInfo.consumerName
        // values.iv_applicant_address = basicInfo.consumerAddress1 + " " + basicInfo.consumerAddress2
        values.iv_tariff_description = basicInfo.tariffDescription
        values.iv_tariff_code = basicInfo.tariffCode
        values.iv_subdivision = basicInfo.subDivName
        values.iv_connection_type = basicInfo.cons_cat
        values.iv_cnic = basicInfo.owner_cnic
        setConsumerID(basicInfo.appNo)
        setName(basicInfo.consumerName)
        setCnicNo(basicInfo.owner_cnic ? basicInfo.owner_cnic : '0000000000000');
        setReferenceNumber(basicInfo.refNo.replace(/ /g, "").slice(0, 14))
        setAreaType(basicInfo.refNo.replace(/ /g, "").slice(-1));
        setReferenceNumberForAPI(basicInfo.refNo.replace(/ /g, ""))
        setPhoneNo(basicInfo.consumerContactNo ? basicInfo.consumerContactNo : '03000000000');
        setEmail(basicInfo.consumerEmail ? basicInfo.consumerEmail : 'example@gmail.com');
        setSectionedLoad(basicInfo.sactionLoad);
        setOldTariff(basicInfo.tariffDescription);
        setOldFatherName(basicInfo.consumerFName);
        setConnectionDate(basicInfo.connDate)

        setIsDataLoaded(true);
      }
      else {
        setIsDataLoaded(false);
        setError('Reference number does not exist!')
      }
      setViewBackdrop(false)
    }
  }

  // Defining function to fetch tariffs list
  const tariffListAPI = async () => {
    var formdata = new FormData();
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    }
    await fetch(cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === "200") {
          setTarifData(result.data)
        }
        else {
          console.log('Tariff API not working properly!')
        }
      })
      .catch(error => console.log('error', error));
  };

  //To fetch tariffs list and current information from APIs
  useEffect(() => {
    if (values.iv_consumer_id.length === 10) {
      tariffListAPI(); // function to fetch tariffs list from API 
      refrenceapi(); // function to fetch current information on behalf of reference number
    }
    else {
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      values.iv_reference_number = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_address = ''

      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_new_name = ""
      values.iv_new_cnic = ""
      values.iv_new_email = ""
      values.iv_new_phone_no = ""
      values.iv_new_father_name = ''
      values.iv_load_type = ""
      values.iv_new_load = ""
      values.iv_new_tariff = ""
      values.iv_applicant_cnic_front = ""
      values.iv_applicant_cnic_back = ""
      values.iv_ownership_document = ""
      values.iv_previous_owner_cnic_front = ''
      values.iv_previous_owner_cnic_back = ''
      values.iv_noc_from_previous_owner = ''
      values.iv_new_owner_affidavite = ""
      values.iv_additional_civic_document = ''
      values.iv_test_report = ""
      values.iv_other_documents = ""
      values.name = ''
      values.phoneNo = ''
      values.email = ''
      values.oldFatherName = ''
      setName()
      setOldFatherName()
      setPhoneNo()
      setEmail()
      values.iv_name = ''
      values.iv_cnic = ''
      values.iv_load_type = ""
      values.iv_application_type = ""
      values.iv_relation_type = ""
      values.iv_applicant_address = ''
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      setSectionedLoad('')
      setChecked(false)
      setApplicantCnicDocumentFrontThumbnail();
      setApplicantCnicDocumentBackThumbnail();
      setAnyOtherDocumentThumbnail('');
      setConsentImageChangeOfNameDocumentThumbnail('');
      setOwnerShipThumbnail();
      setCnicPreviousOwnerFrontThumbnail();
      setCnicPreviousOwnerBackThumbnail();
      setNocPreviousOwnerThumbnail();
      setAffidaviteApplicantThumbnail();
      setAdditionalCivicDocumentThumbnail();
      setConsentImageChangeOfNameDocument();
      setAnyOtherDocument();
      setAdditionalCivicDocument();
      setAffidaviteApplicant();
      setNocPreviousOwner();
      setCnicPreviousOwnerBack();
      setCnicPreviousOwnerFront();
      setAuthorityLetter();
      setOwnerShip();
      setApplicantCnicDocumentBack();
      setCnicPreviousOwnerFront();
      setSelectedOptions({
        name: false,
        load: false,
        tariff: false,
      });
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    if (values.iv_reference_number.length === 14) {
      tariffListAPI(); // function to fetch tariffs list from API 
      refrenceapi(); // function to fetch current information on behalf of reference number
    } else {
      setIsDataLoaded(false)
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_address = ''

      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_new_name = ""
      values.iv_new_cnic = ""
      values.iv_new_email = ""
      values.iv_new_phone_no = ""
      values.iv_new_father_name = ''
      values.iv_load_type = ""
      values.iv_new_load = ""
      values.iv_new_tariff = ""
      values.iv_applicant_cnic_front = ""
      values.iv_applicant_cnic_back = ""
      values.iv_ownership_document = ""
      values.iv_previous_owner_cnic_front = ''
      values.iv_previous_owner_cnic_back = ''
      values.iv_noc_from_previous_owner = ''
      values.iv_new_owner_affidavite = ""
      values.iv_additional_civic_document = ''
      values.iv_test_report = ""
      values.iv_other_documents = ""
      values.name = ''
      values.phoneNo = ''
      values.email = ''
      values.oldFatherName = ''
      values.iv_load_type = ""
      values.iv_application_type = ""
      values.iv_relation_type = ""
      setName()
      setOldFatherName()
      setPhoneNo()
      setEmail()
      values.iv_name = ''
      values.iv_cnic = ''
      values.iv_applicant_address = ''
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_phase = ''
      values.iv_meter_type = ''
      setSectionedLoad('')
      setChecked(false)
      setApplicantCnicDocumentFrontThumbnail();
      setApplicantCnicDocumentBackThumbnail();
      setAnyOtherDocumentThumbnail('');
      setConsentImageChangeOfNameDocumentThumbnail('');
      setOwnerShipThumbnail();
      setCnicPreviousOwnerFrontThumbnail();
      setCnicPreviousOwnerBackThumbnail();
      setNocPreviousOwnerThumbnail();
      setAffidaviteApplicantThumbnail();
      setAdditionalCivicDocumentThumbnail();
      setConsentImageChangeOfNameDocument();
      setAnyOtherDocument();
      setAdditionalCivicDocument();
      setAffidaviteApplicant();
      setNocPreviousOwner();
      setCnicPreviousOwnerBack();
      setCnicPreviousOwnerFront();
      setAuthorityLetter();
      setOwnerShip();
      setApplicantCnicDocumentBack();
      setCnicPreviousOwnerFront();
      setSelectedOptions({
        name: false,
        load: false,
        tariff: false,
      });
    }
  }, [values.iv_reference_number])

  useEffect(() => {
    if (referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        // Handle circle not found
        console.error(`Circle not found with code: ${circleCode}. Contact Admin!`);
        setError(`Circle not found with code: ${circleCode}`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        // Handle division not found
        console.error(`Division not found with code: ${divisionCode}`);
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        // Handle subdivision not found
        console.error(`Subdivision not found with code: ${subDivisionCode}`);
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(subDivisionsArray)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {

    values.iv_application_type = 1 || 2 || 3 || 4 || 5 || 6 || 7
    setPageTitle("Change of Attributes")
    setCoaStatusBarArray([{
      title1: 'APPLICATION',
      title2: 'DETAIL',
      status: 0
    },
    {
      title1: `APPLICANT'S`,
      title2: 'CNIC',
      status: 0
    },
    {
      title1: 'PROOF OF',
      title2: 'OWNERSHIP',
      status: 0
    },
    {
      title1: 'ELECTRICITY',
      title2: `BILL`,
      status: 0
    },
    {
      title1: 'FBR',
      title2: 'DOCUMENT',
      status: 0
    },])


  }, [])

  useEffect(() => {
    if (values.iv_application_type == 1) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_name &&
        values.iv_new_cnic &&
        values.iv_new_phone_no &&
        values.iv_new_father_name &&
        values.iv_relation_type
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    } else if (values.iv_application_type == 2) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_load &&
        values.iv_load_type
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    } else if (values.iv_application_type == 3) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_tariff
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    } else if (values.iv_application_type == 4) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_tariff &&
        values.iv_new_load &&
        values.iv_load_type &&
        values.iv_new_name &&
        values.iv_new_cnic &&
        values.iv_new_phone_no &&
        values.iv_new_father_name &&
        values.iv_relation_type
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    } else if (values.iv_application_type == 5) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_name &&
        values.iv_new_cnic &&
        values.iv_new_phone_no &&
        values.iv_new_father_name &&
        values.iv_relation_type &&
        values.iv_new_load &&
        values.iv_load_type
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
    else if (values.iv_application_type == 6) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_name &&
        values.iv_new_cnic &&
        values.iv_new_phone_no &&
        values.iv_new_father_name &&
        values.iv_relation_type &&
        values.iv_new_tariff
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
    else if (values.iv_application_type == 7) {
      if (
        (values.iv_consumer_id || values.iv_reference_number) &&
        values.iv_new_tariff &&
        values.iv_new_load &&
        values.iv_load_type
      ) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[0] = {
            ...updatedArray[0],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }

  }, [values, loadChangeType])

  useEffect(() => {
    if (applicantCnicFront && applicantCnicBack) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [applicantCnicFront, applicantCnicBack])

  useEffect(() => {
    if (ownerShip) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[2] = {
          ...updatedArray[2],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[2] = {
          ...updatedArray[2],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [ownerShip])

  useEffect(() => {
    if (electricityBill) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[3] = {
          ...updatedArray[3],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[3] = {
          ...updatedArray[3],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [electricityBill])

  useEffect(() => {
    if (fbrDocument) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[4] = {
          ...updatedArray[4],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[4] = {
          ...updatedArray[4],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [fbrDocument])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (cnicPreviousOwnerFront && cnicPreviousOwnerBack) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [cnicPreviousOwnerFront, cnicPreviousOwnerBack])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (affidaviteApplicant) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[4] = {
            ...updatedArray[4],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[4] = {
            ...updatedArray[4],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [affidaviteApplicant])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (additionalCivicDocument) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[5] = {
            ...updatedArray[5],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[5] = {
            ...updatedArray[5],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [additionalCivicDocument])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (anyOtherDocument) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[6] = {
            ...updatedArray[6],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[6] = {
            ...updatedArray[6],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [anyOtherDocument])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (consentImageChangeOfNameDocument) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[7] = {
            ...updatedArray[7],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[7] = {
            ...updatedArray[7],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [consentImageChangeOfNameDocument])

  useEffect(() => {
    if (values.iv_application_type === 2) {
      if (otherDocuments) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[4] = {
            ...updatedArray[4],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [otherDocuments])

  useEffect(() => {
    if (values.iv_application_type === 2) {
      if (authorityLetter) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
        // } else {
        //   setCoaStatusBarArray(prevArray => {
        //     const updatedArray = [...prevArray];
        //     updatedArray[3] = {
        //       ...updatedArray[3],
        //       status: 0 // Set the status to the desired value
        //     };
        //     return updatedArray;
        //   })
      }
    }
  }, [authorityLetter])

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesLookupData", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === '200') {
          console.log(result.data, "dkldkasdjaskdadsds;a")
          setLookUpDataOfCON(result.data)
        }
      })
      .catch((error) => console.error(error));
  }, [token, cfpBaseUrl])

  const [typeValue, setTypeValue] = useState(() => {
    return typeof values?.iv_application_type === 'number' ? values.iv_application_type : null;
  });

  const computeTypeValue = ({ name, load, tariff }) => {
    if (name && load && tariff) return 4;
    if (name && load && !tariff) return 5;
    if (name && !load && tariff) return 6;
    if (!name && load && tariff) return 7;
    if (name && !load && !tariff) return 1;
    if (!name && load && !tariff) return 2;
    if (!name && !load && tariff) return 3;
    return null;
  };

  const handleCheckboxChange = (optionKey) => {
    setSelectedOptions((prev) => {
      const next = { ...prev, [optionKey]: !prev[optionKey] };
      const newTypeValue = computeTypeValue(next);
      setTypeValue(newTypeValue);
      if (values && typeof values === 'object') {
        values.iv_application_type = newTypeValue;
      }
      return next;
    });
  };
  useEffect(() => {
    values.iv_application_type = null
  }, [])
  return (
    console.log(getChangeOfText(selectedOptions), "checkboxValues"),
    <>
      <Grid container className="nC">
        <Box className='nCContainer'>
          <div className='headingBarDiv'>
            <h3 className='heading'>
              {pageTitle}
            </h3>
            <StepProgressBar array={coaStatusBarArray} />
          </div>

          <form className='ncform' style={{ overflowX: 'hidden', overflowY: 'auto' }}>


            <Typography variant="h6" className="groupTitle">
              <div className='redCell'></div>
              Applicant's Particulars
            </Typography>

            <Grid container spacing={2} className='container'>

              <Grid item xs={12}>
                <Grid container spacing={0} alignItems="center">

                  {/* ── 1. Search By (radios) ── */}
                  <Grid item xs={12} sm={4}>
                    <Typography className="fieldLabel">Search By</Typography>
                    <FormControl>
                      <RadioGroup row name="iv_search_by" value={searchBy} onChange={SearchBy}>
                        <FormControlLabel value="referenceNo" control={<Radio size="small" />} label="Reference No." />
                        <FormControlLabel value="consumerId" control={<Radio size="small" />} label="Customer ID." />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {/* ── 2. Conditional Input (aligned) ── */}
                  <Grid
                    item
                    xs={12}
                    sm={3}
                    sx={{
                      pl: { xs: 0, sm: 1 },
                      pr: { xs: 0, sm: 1 },
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: -25
                    }}
                  >
                    {searchBy === 'referenceNo' ? (
                      <>
                        <Typography className="fieldLabel" sx={{ mb: 0.5 }}>Reference No.</Typography>
                        <TextField
                          name="iv_reference_number"
                          value={values.iv_reference_number ?? ''}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 14 }}
                          className="textInputField"
                          autoComplete="off"
                          size="small"
                          sx={{ '& .MuiInputBase-root': { height: 36 } }}
                          error={Boolean(touched.iv_reference_number && errors.iv_reference_number)}
                        />
                        {touched.iv_reference_number && errors.iv_reference_number && (
                          <Typography color="error" variant="caption" sx={{ mt: 0.5, fontSize: '0.75rem' }}>
                            {errors.iv_reference_number}
                          </Typography>
                        )}
                      </>
                    ) : searchBy === 'consumerId' ? (
                      <>
                        <Typography className="fieldLabel" sx={{ mb: 0.5 }}>Customer ID.</Typography>
                        <TextField
                          name="iv_consumer_id"
                          value={values.iv_consumer_id ?? ''}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 10 }}
                          className="textInputField"
                          autoComplete="off"
                          size="small"
                          sx={{ '& .MuiInputBase-root': { height: 36 } }}
                          error={Boolean(touched.iv_consumer_id && errors.iv_consumer_id)}
                        />
                        {touched.iv_consumer_id && errors.iv_consumer_id && (
                          <Typography color="error" variant="caption" sx={{ mt: 0.5, fontSize: '0.75rem' }}>
                            {errors.iv_consumer_id}
                          </Typography>
                        )}
                      </>
                    ) : null}
                  </Grid>

                  {/* ── 3. Apply for change of (label + checkboxes) ── */}
                  <Grid item xs={12} sm={5} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                      {/* label */}
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: '1.25rem',
                          whiteSpace: 'nowrap',
                          mr: 1,
                        }}
                      >
                        Apply for change of :
                      </Typography>

                      {/* checkboxes */}
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedOptions.name}
                              onChange={() => handleCheckboxChange('name')}
                              disabled={!isDataLoaded}
                              size="large"
                            />
                          }
                          label="Name"
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedOptions.load}
                              onChange={() => handleCheckboxChange('load')}
                              disabled={!isDataLoaded}
                              size="large"
                            />
                          }
                          label="Load"
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedOptions.tariff}
                              onChange={() => handleCheckboxChange('tariff')}
                              disabled={!isDataLoaded}
                              size="large"
                            />
                          }
                          label="Tariff"
                          sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.95rem' } }}
                        />
                      </FormGroup>
                    </Box>

                    {/* optional validation error */}
                    {touched.iv_application_type && errors.iv_application_type && (
                      <Typography color="error" fontSize="0.75rem" sx={{ mt: 0.5, ml: { sm: 12 } }}>
                        {errors.iv_application_type}
                      </Typography>
                    )}
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1} alignItems="start">
                  <Grid item xs={12} sm={3.5}>
                    <Typography className="fieldLabel">Current Owner Name</Typography>
                    <TextField
                      disabled
                      required
                      name="iv_applicant_name"
                      value={
                        values.iv_father_name
                          ? `${values.iv_applicant_name?.trim()} / ${values.iv_father_name?.trim()}`
                          : values.iv_applicant_name?.trim()
                      }
                      className="textInputField"
                      size="small"
                      sx={{
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiInputBase-input.Mui-disabled': {
                          backgroundColor: '#f2f4f6',
                          color: '#000',
                          WebkitTextFillColor: '#000',
                        },
                      }}
                    />
                    <Box className="from-Error-load" sx={{ mt: 0.5 }}>
                      {errors.iv_applicant_name && touched.iv_applicant_name ? errors.iv_applicant_name : null}
                    </Box>
                  </Grid>

                  {/* ---------- CNIC (shorter) ---------- */}
                  <Grid item xs={12} sm={2.5}>
                    <Typography className="fieldLabel">NIC. / CNIC. / NICOP.</Typography>
                    <TextField
                      required
                      disabled
                      name="iv_applicant_cnic"
                      value={values.iv_applicant_cnic}
                      className="textInputField1"
                      size="small"
                      sx={{
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiInputBase-input.Mui-disabled': {
                          backgroundColor: '#f2f4f6',
                          color: '#000',
                          WebkitTextFillColor: '#000',
                        },
                      }}
                    />
                    <Box className="from-Error" sx={{ mt: 0.5 }}>
                      {errors.iv_applicant_cnic && touched.iv_applicant_cnic ? errors.iv_applicant_cnic : null}
                    </Box>
                  </Grid>

                  {/* ---------- Address ---------- */}
                  <Grid item xs={12} sm={3}>
                    <Typography className="fieldLabel">Address</Typography>
                    <TextField
                      required
                      disabled
                      name="iv_applicant_address"
                      value={values.iv_applicant_address}
                      className="textInputField1"
                      size="small"
                      sx={{
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiInputBase-input.Mui-disabled': {
                          backgroundColor: '#f2f4f6',
                          color: '#000',
                          WebkitTextFillColor: '#000',
                        },
                      }}
                    />
                    <Box className="from-Error" sx={{ mt: 0.5 }}>
                      {errors.iv_applicant_address && touched.iv_applicant_address ? errors.iv_applicant_address : null}
                    </Box>
                  </Grid>

                  {/* ---------- Telco Dropdown ---------- */}
                  <Grid item xs={6} sm={1}>
                    <Typography className="fieldLabel">Telco</Typography>
                    <TextField
                      select
                      required
                      name="iv_telco"
                      value={values.iv_telco ?? ''}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={Boolean(touched.iv_telco && errors.iv_telco)}
                      className="textInputField"
                      size="small"
                      SelectProps={{ native: true }}
                      sx={{
                        '& .MuiInputBase-root': { height: 36 },
                        '& .MuiSelect-select': { padding: '6px 10px' },
                      }}
                    >
                      {/* <option value="">--</option>
                      <option value="1">Jazz</option>
                      <option value="1">Warid</option>
                      <option value="2">Ufone</option>
                      <option value="2">Onic</option>
                      <option value="3">Telenor</option>
                      <option value="4">Zong</option>
                      <option value="5">SCom</option> */}

                      <option value={0}>Select</option>
                      <option value={1}>Jazz</option>
                      <option value={1}>Warid</option>
                      <option value={2}>Ufone</option>
                      <option value={2}>Onic</option>
                      <option value={3}>Telenor</option>
                      <option value={4}>Zong</option>
                      <option value={5}>SCom</option>
                    </TextField>

                    {touched.iv_telco && errors.iv_telco && (
                      <Typography color="error" variant="caption" sx={{ mt: 0.5, fontSize: '0.75rem' }}>
                        {errors.iv_telco}
                      </Typography>
                    )}
                  </Grid>

                  {/* ---------- Phone No. ---------- */}
                  <Grid item xs={6} sm={1.5}>
                    <Typography className="fieldLabel">Phone No.</Typography>
                    <TextField
                      required
                      name="iv_applicant_phone_no"
                      value={values.iv_applicant_phone_no}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 11 }}
                      className="textInputField"
                      size="small"
                      sx={{ '& .MuiInputBase-root': { height: 36 } }}
                    />
                    <Box className="from-Error" sx={{ mt: 0.5 }}>
                      {errors.iv_applicant_phone_no && touched.iv_applicant_phone_no ? errors.iv_applicant_phone_no : null}
                    </Box>
                  </Grid>

                </Grid>
              </Grid>

            </Grid>
            {/* Name Section */}
            {
              (values.iv_application_type == 1 || values.iv_application_type == 4 || values.iv_application_type == 5 || values.iv_application_type == 6) &&
              < Grid container className='container'>
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel'>New Name</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_new_name"
                    value={values.iv_new_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label=""
                    id="iv_new_name"
                    placeholder=''
                    className="textInputField"
                  />
                  <Box className="from-Error-load">
                    {
                      errors.iv_new_name && touched.iv_new_name ?
                        errors.iv_new_name
                        : null
                    }
                  </Box>
                </Grid>
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className="fieldLabel">Relation Type</Typography>
                  <FormControl
                    className="form-control"
                    sx={{
                      marginLeft: '0 !important',
                      paddingLeft: 0,
                    }}
                    style={{ marginLeft: 0 }}
                    fullWidth
                  >
                    <Select
                      labelId="relation-type-label"
                      id="iv_relation_type"
                      name="iv_relation_type"
                      value={values.iv_relation_type || ''}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "iv_relation_type",
                            value: parseInt(e.target.value, 10),
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      className="textInputField"
                      style={{ fontSize: "14px" }}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>Select Relation Type</em>
                      </MenuItem>

                      {lookUpDataOfCON?.lookupGuardianType.map((item) => (
                        <MenuItem
                          key={item.typeId}
                          value={item.typeId}
                          style={{ fontSize: "14px" }}
                        >
                          {item.typeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Box className="from-Error-load">
                    {errors.iv_relation_type && touched.iv_relation_type ? errors.iv_relation_type : null}
                  </Box>

                </Grid>
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className="fieldLabel"> {(values.iv_relation_type == 1 || values.iv_relation_type == 2) ? `Father's ` : values.iv_relation_type == 3 ? `Husband's ` : values.iv_relation_type == 4 ? `Care of  ` : 'Father of  '}Name</Typography>
                  <TextField
                    required
                    type="text"
                    name="iv_new_father_name"
                    value={values.iv_new_father_name}
                    autoComplete="off"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="iv_new_father_name"
                    className="textInputField"
                  />
                  <Box className="from-Error">
                    {errors.iv_new_father_name && touched.iv_new_father_name
                      ? errors.iv_new_father_name
                      : null}
                  </Box>
                </Grid>
                <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >CNIC No.</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_new_cnic"
                    value={values.iv_new_cnic}
                    onChange={(e) => {
                      const regex = /^[0-9\b]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        handleChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 13 }}
                    label=""
                    id="newCnicNo"
                    placeholder=''
                    className="textInputField"
                  />
                  <Box className="from-Error-load">
                    {
                      errors.iv_new_cnic && touched.iv_new_cnic ?
                        errors.iv_new_cnic
                        : null
                    }
                  </Box>
                </Grid>
                {/* <Grid item xs={2} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel' >Phone No.</Typography>
                  <TextField
                    required
                    type='double'
                    name="iv_new_phone_no"
                    label=""
                    value={values.iv_new_phone_no}
                    onChange={(e) => {
                      const regex = /^[0-9\b]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        handleChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 11 }}
                    id="newNumber"
                    placeholder=''
                    className="textInputField"
                  />
                  <Box className='from-Error-load'>
                    {
                      errors.iv_new_phone_no && touched.iv_new_phone_no ? errors.iv_new_phone_no : null
                    }
                  </Box>
                </Grid> */}
                <Grid item xs={2} >
                  <Typography className='fieldLabel' > Email<span className='email-optinal'>(optional)</span></Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_new_email"
                    label=""
                    value={values.iv_new_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="newEmail"
                    placeholder=''
                    className="textInputField"
                  />
                  <Box className='from-Error-load'>
                    {
                      errors.iv_new_email && touched.iv_new_email ?
                        errors.iv_new_email : null
                    }
                  </Box>
                </Grid>
              </Grid>
            }
            {/* Tariff Section */}
            {(values.iv_application_type == 3 ||
              values.iv_application_type == 4 ||
              values.iv_application_type == 6 ||
              values.iv_application_type == 7) && (
                <Grid container className="container">
                  {/* Old Tariff */}
                  <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                    <Typography className="fieldLabel">Old Tariff</Typography>
                    <TextField
                      disabled
                      type="name"
                      name="oldTariff"
                      value={oldTariff}
                      onChange={OldTariff}
                      label=""
                      id="oldTariff"
                      placeholder=""
                      className="textInputField1"
                    />
                  </Grid>

                  {/* New Tariff */}
                  <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                    <Typography className="fieldLabel">New Tariff</Typography>
                    <Select
                      autoWidth={false}
                      value={values.iv_new_tariff}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      displayEmpty
                      name="iv_new_tariff"
                      id="iv_new_tariff"
                      className="dropdownList"
                      error={touched.iv_new_tariff && Boolean(errors.iv_new_tariff)}
                    >
                      <MenuItem value="">
                        <em>Select New Tariff</em>
                      </MenuItem>
                      {tarifData.map((data, index) => (
                        <MenuItem key={index} value={data.tariffName}>
                          {data.tariffName} - {data.tariffDesc}
                        </MenuItem>
                      ))}
                    </Select>

                    {touched.iv_new_tariff && errors.iv_new_tariff && (
                      <Box className="from-Error-load">{errors.iv_new_tariff}</Box>
                    )}
                  </Grid>

                  {/* NTN No. */}
                  {values.iv_new_tariff &&
                    values.iv_new_tariff.replace('-', '').match(/^(A2|B)/) && (
                      <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                        <Typography className="fieldLabel">
                          NTN No.<span style={{ color: 'red' }}> *</span>
                        </Typography>
                        <TextField
                          required
                          type="text"
                          name="iv_ntn_num"
                          label=""
                          value={values.iv_ntn_num}
                          onChange={(e) => {
                            const regex = /^[0-9]*\.?[0-9]*$/;
                            if (e.target.value === "" || regex.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 13 }}
                          className="textInputField"
                          placeholder=""
                        />
                        <Box className="from-Error-load">
                          {errors.iv_ntn_num && touched.iv_ntn_num ? errors.iv_ntn_num : null}
                        </Box>
                      </Grid>
                    )
                  }


                </Grid>
              )}

            {/* Load Section */}
            {
              (values.iv_application_type == 2 || values.iv_application_type == 4 || values.iv_application_type == 5 || values.iv_application_type == 7) &&
              <Grid container className='container'>
                <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel'>Load Change Type</Typography>
                  <FormControl
                    className="form-control"
                    sx={{
                      marginLeft: '0 !important',
                      paddingLeft: 0,
                    }}
                    style={{ marginLeft: 0 }}
                    fullWidth
                  >
                    <Select
                      labelId="load-type-label"
                      id="iv_load_type"
                      name="iv_load_type"
                      value={values.iv_load_type || ''}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "iv_load_type",
                            value: parseInt(e.target.value, 10),
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      className="textInputField"
                      style={{ fontSize: "14px" }}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>Select Load Change Type</em>
                      </MenuItem>

                      {lookUpDataOfCON?.lookupLoadChangeType.map((item) => (
                        <MenuItem
                          key={item.typeId}
                          value={item.typeId}
                          style={{ fontSize: "14px" }}
                        >
                          {item.typeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Box className="from-Error-load">
                    {errors.iv_load_type && touched.iv_load_type ? errors.iv_load_type : null}
                  </Box>
                </Grid>

                <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel'> Sanctioned Load (kW)</Typography>
                  <TextField
                    disabled
                    type='name'
                    name="sectionedLoad"
                    value={sectionedLoad}
                    onChange={SectionedLoad}
                    label=""
                    id="sectionedLoad"
                    placeholder=''
                    className="textInputField1"
                  />
                </Grid>
                <Grid item xs={4} sx={{ paddingRight: '20px' }}>
                  <Typography className='fieldLabel'>New Load (kW)</Typography>
                  <TextField
                    required
                    type='text'
                    name="iv_new_load"
                    label=""
                    value={values.iv_new_load}
                    onChange={(e) => {
                      const regex = /^[0-9]*\.?[0-9]*$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        handleChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                    inputProps={{ maxLength: 6 }}
                    id="newLoad"
                    className="textInputField"
                    placeholder=''
                  />
                  <Box className="from-Error-load">
                    {errors.iv_new_load && touched.iv_new_load ? errors.iv_new_load : null}
                  </Box>
                </Grid>

              </Grid>

            }


            <Typography variant="h6" className="groupTitleDocuments">
              Required Documents
              {
                values.iv_application_type === 0 &&
                <span style={{ float: 'right', color: 'black', fontSize: '14px', margin: 'auto', color: 'white' }}>
                  <a href='https://eopsapi.pitc.com.pk:8040/CON%20Affidavit%20and%20NOC%20Temp.pdf' target='_blank' style={{ color: 'white' }}>Download the template of NOC and Affidavite.</a>
                </span>
              }
            </Typography>
            <Grid container spacing={1} className='documentsContainer' >
              <Grid item lg='1.25' >
                <Typography className='documentLabel' >1- Applicant's CNIC.</Typography>
              </Grid>
              <Grid item lg=".875">
                {applicantCnicFront ? (
                  <>
                    <Button
                      varient="outlined"
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentFront("");
                          }}
                        />
                      }
                    >
                      {applicantCnicFrontThumbnail &&
                        isImage(applicantCnicFront) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicFrontThumbnail}
                            alt="Applicant CNIC Front"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicFront) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                              {/* <p>{applicantCnicFrontFileName}</p> */}
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Front
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_front"
                        name="iv_applicant_cnic_front"
                        type="file"
                        onChange={ApplicantCnicDocumentFront}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        applicantCnicFrontError ?
                          applicantCnicFrontError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_applicant_cnic_front ?
                          errors.iv_applicant_cnic_front : null
                      }
                    </Box>
                  </>
                )}
              </Grid>
              <Grid item lg=".875">
                {applicantCnicBack ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setApplicantCnicDocumentBack("");
                          }}
                        />
                      }
                    >
                      {applicantCnicBackThumbnail &&
                        isImage(applicantCnicBack) ? (
                        <div className="btn-div">
                          <img
                            src={applicantCnicBackThumbnail}
                            alt="Applicant CNIC Back"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(applicantCnicBack) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Back
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_applicant_cnic_back"
                        name="iv_applicant_cnic_back"
                        type="file"
                        onChange={ApplicantCnicDocumentBack}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        applicantCnicBackError ?
                          applicantCnicBackError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_applicant_cnic_back ?
                          errors.iv_applicant_cnic_back : null
                      }
                    </Box>
                  </>
                )}
              </Grid>
              <Grid item lg='1.75' >
                <Typography className='documentLabel' >2- Proof of Ownership</Typography>
              </Grid>
              <Grid item lg='1.25'>
                {ownerShip ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setOwnerShip("");
                          }}
                        />
                      }
                    >
                      {ownerShipThumbnail &&
                        isImage(ownerShip) ? (
                        <div className="btn-div">
                          <img
                            src={ownerShipThumbnail}
                            alt="Ownership"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(ownerShip) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_ownership_document"
                        name="iv_ownership_document"
                        type="file"
                        onChange={OwnerShip}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        ownerShipError ?
                          ownerShipError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_ownership_document ?
                          errors.iv_ownership_document : null
                      }
                    </Box>
                  </>
                )}
              </Grid>
              <Grid item lg='1.75' >
                <Typography className='documentLabel' >3- Electricity Bill</Typography>
              </Grid>
              <Grid item lg='1.25'>
                {electricityBill ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setElectricityBill("");
                          }}
                        />
                      }
                    >
                      {electricityBillThumbnail &&
                        isImage(electricityBill) ? (
                        <div className="btn-div">
                          <img
                            src={electricityBillThumbnail}
                            alt="Ownership"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(electricityBill) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_electricity_bill_document"
                        name="iv_electricity_bill_document"
                        type="file"
                        onChange={ApplicantElectricityBill}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        electricityBillError ?
                          electricityBillError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_electricity_bill_document ?
                          errors.iv_electricity_bill_document : null
                      }
                    </Box>
                  </>
                )}
              </Grid>

              <Grid item lg='1.75' >
                <Typography className='documentLabel' >4- FBR Document</Typography>
              </Grid>

              <Grid item lg='1.25'>
                {fbrDocument ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setFbrDocument("");
                          }}
                        />
                      }
                    >
                      {fbrThumbnail &&
                        isImage(fbrDocument) ? (
                        <div className="btn-div">
                          <img
                            src={fbrThumbnail}
                            alt="Ownership"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(fbrDocument) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_fbr_document"
                        name="iv_fbr_document"
                        type="file"
                        onChange={ApplicantFbr}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        fbrError ?
                          fbrError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_fbr_document ?
                          errors.iv_fbr_document : null
                      }
                    </Box>
                  </>
                )}
              </Grid>

              <Grid item lg='1.75' >
                <Typography className='documentLabel' >5- Any Other Document (Optional)</Typography>
              </Grid>

              <Grid item lg='1.25'>
                {anyOtherDocument ? (
                  <>
                    <Button
                      component="label"
                      startIcon={
                        <CloseIcon
                          className="button-with-image"
                          onClick={() => {
                            setAnyOtherDocument("");
                          }}
                        />
                      }
                    >
                      {anyOtherDocumentThumbnail &&
                        isImage(anyOtherDocument) ? (
                        <div className="btn-div">
                          <img
                            src={anyOtherDocumentThumbnail}
                            alt="Ownership"
                            width="80"
                          />
                        </div>
                      ) : (
                        <span>
                          {isPdf(anyOtherDocument) ? (
                            <div className="btn-div">
                              <img src={pdfIcon} alt="PDF" width="80" />
                            </div>
                          ) : (
                            "Other file type"
                          )}
                        </span>
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<FileUploadOutlinedIcon />}
                      className="btn"
                    >
                      Upload
                      <input
                        hidden
                        accept={documentExtensions}
                        id="iv_any_other_document"
                        name="iv_any_other_document"
                        type="file"
                        onChange={ApplicantAnyOtherDocument}
                      />
                    </Button>
                    <Box className="documentError">
                      {
                        fbrError ?
                          fbrError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_any_other_document ?
                          errors.iv_any_other_document : null
                      }
                    </Box>
                  </>
                )}
              </Grid>
              {/* {
                (values.iv_application_type !== 0 && values.iv_connection_type && !values.iv_connection_type.toLowerCase().startsWith('dom')) &&
                <>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel' >3- Authority Letter</Typography>
                    <Box className="documentError">
                      {
                        authorityLetterError ?
                          authorityLetterError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_authority_letter ?
                          errors.iv_authority_letter : null
                      }
                    </Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {authorityLetter ? (
                      <>
                        <Button
                          component="label"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setAuthorityLetter("");
                              }}
                            />
                          }
                        >
                          {authorityLetterThumbnail &&
                            isImage(authorityLetter) ? (
                            <div className="btn-div">
                              <img
                                src={authorityLetterThumbnail}
                                alt="Ownership"
                                width="80"
                              />
                            </div>
                          ) : (
                            <span>
                              {isPdf(authorityLetter) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Upload
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_authority_letter"
                            name="iv_authority_letter"
                            type="file"
                            onChange={AuthorityLetter}
                          />
                        </Button>
                        <Box className="documentError">
                          {
                            authorityLetterError ?
                              authorityLetterError : null
                          }
                        </Box>
                        <Box className="documentError">
                          {
                            errors.iv_authority_letter ?
                              errors.iv_authority_letter : null
                          }
                        </Box>
                      </>
                    )}
                  </Grid>
                </>
              }
              {
                values.iv_application_type === 0 &&
                <>
                  <Grid item lg='1.25' >
                    <Typography className='documentLabel'>3- Previous Owner's CNIC.</Typography>


                  </Grid>
                  <Grid item lg=".875">
                    {
                      cnicPreviousOwnerFront ? (
                        <>
                          <Button
                            varient="outlined"
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setCnicPreviousOwnerFront("");
                                }}
                              />
                            }
                          >
                            {cnicPreviousOwnerFrontThumbnail &&
                              isImage(cnicPreviousOwnerFront) ? (
                              <div className="btn-div">
                                <img
                                  src={cnicPreviousOwnerFrontThumbnail}
                                  alt="Previous Owner CNIC Front"
                                  width="80"
                                />
                              </div>
                            ) : (
                              <span>
                                {isPdf(cnicPreviousOwnerFront) ? (
                                  <div className="btn-div">
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                  </div>
                                ) : (
                                  "Other file type"
                                )}
                              </span>
                            )}
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Front
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_previous_owner_cnic_front"
                              name="iv_previous_owner_cnic_front"
                              type="file"
                              onChange={PreviousOwnerCNICFront}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              cnicPreviousOwnerFront == '' ?
                                cnicPreviousOwnerFrontError : null
                            }
                          </Box>
                          <Box className="documentError">
                            {errors.iv_previous_owner_cnic_front &&
                              touched.iv_previous_owner_cnic_front
                              ? errors.iv_previous_owner_cnic_front
                              : null}
                          </Box>
                        </>
                      )}
                  </Grid>
                  <Grid item lg=".875">
                    {cnicPreviousOwnerBack ? (
                      <>
                        <Button
                          component="label"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setCnicPreviousOwnerBack("");
                              }}
                            />
                          }
                        >
                          {cnicPreviousOwnerBackThumbnail &&
                            isImage(cnicPreviousOwnerBack) ? (
                            <div className="btn-div">
                              <img
                                src={cnicPreviousOwnerBackThumbnail}
                                alt="Previous Owner CNIC Back"
                                width="80"
                              />
                            </div>
                          ) : (
                            <span>
                              {isPdf(cnicPreviousOwnerBack) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Back
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_previous_owner_cnic_back"
                            name="iv_previous_owner_cnic_back"
                            type="file"
                            onChange={PreviousOwnerCNICBack}
                          />
                        </Button>
                        <Box className="documentError">
                          {
                            cnicPreviousOwnerBack == '' ?
                              cnicPreviousOwnerBackError : null
                          }
                        </Box>
                        <Box className="documentError">
                          {errors.iv_previous_owner_cnic_back &&
                            touched.iv_previous_owner_cnic_back
                            ? errors.iv_previous_owner_cnic_back
                            : null}
                        </Box>
                      </>
                    )}
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>4- Affidavite from Applicant</Typography>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      affidaviteApplicant ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setAffidaviteApplicant("");
                                }}
                              />
                            }
                          >
                            {
                              affidaviteApplicantThumbnail &&
                                isImage(affidaviteApplicant) ? (
                                <div className="btn-div">
                                  <img
                                    src={affidaviteApplicantThumbnail}
                                    alt="Affidavite Applicant"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(affidaviteApplicant) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_new_owner_affidavite"
                              name="iv_new_owner_affidavite"
                              type="file"
                              onChange={AffidaviteApplicant}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              affidaviteApplicant == '' ?
                                affidaviteApplicantError : null
                            }
                          </Box>
                          <Box className='documentError'>{errors.iv_new_owner_affidavite && touched.iv_new_owner_affidavite ? (errors.iv_new_owner_affidavite) : null}</Box>

                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>5- NOC from Previous Owner (opitional)</Typography>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      nocPreviousOwner ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setNocPreviousOwner("");
                                }}
                              />
                            }
                          >
                            {
                              nocPreviousOwnerThumbnail &&
                                isImage(nocPreviousOwner) ? (
                                <div className="btn-div">
                                  <img
                                    src={nocPreviousOwnerThumbnail}
                                    alt="NOC Previous Owner"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(nocPreviousOwner) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_noc_from_previous_owner"
                              name="iv_noc_from_previous_owner"
                              type="file"
                              onChange={NocPreviousOwner}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              nocPreviousOwner == '' ?
                                nocPreviousOwnerError : null
                            }
                          </Box>
                          <Box className='documentError'>{errors.iv_noc_from_previous_owner && touched.iv_noc_from_previous_owner ? (errors.iv_noc_from_previous_owner) : null}</Box>

                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>6- Additional Document from Civic Authority (opitional)</Typography>
                    <Box className='documentError'>{errors.iv_additional_civic_document && touched.iv_additional_civic_document ? (errors.iv_additional_civic_document) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      additionalCivicDocument ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setAdditionalCivicDocument("");
                                }}
                              />
                            }
                          >
                            {
                              additionalCivicDocumentThumbnail &&
                                isImage(additionalCivicDocument) ? (
                                <div className="btn-div">
                                  <img
                                    src={additionalCivicDocumentThumbnail}
                                    alt="Additional Civic Document"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(additionalCivicDocument) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_additional_civic_document"
                              name="iv_additional_civic_document"
                              type="file"
                              onChange={AdditionalCivicDocument}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              additionalCivicDocument == '' ?
                                additionalCivicDocumentError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>7- Any Other Document (Optional)</Typography>
                    <Box className='documentError'>{errors.iv_any_other_document && touched.iv_any_other_document ? (errors.iv_any_other_document) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      anyOtherDocument ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setAnyOtherDocument("");
                                }}
                              />
                            }
                          >
                            {
                              anyOtherDocumentThumbnail &&
                                isImage(anyOtherDocument) ? (
                                <div className="btn-div">
                                  <img
                                    src={anyOtherDocumentThumbnail}
                                    alt="Any Other Document"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(anyOtherDocument) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_any_other_document"
                              name="iv_any_other_document"
                              type="file"
                              onChange={AnyOtherDocument}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              anyOtherDocument == '' ?
                                anyOtherDocumentError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>8- Consent Image Change of Name (opitional)</Typography>
                    <Box className='documentError'>{errors.iv_consent_image_change_of_name && touched.iv_consent_image_change_of_name ? (errors.iv_consent_image_change_of_name) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      consentImageChangeOfNameDocument ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setConsentImageChangeOfNameDocument("");
                                }}
                              />
                            }
                          >
                            {
                              consentImageChangeOfNameDocumentThumbnail &&
                                isImage(consentImageChangeOfNameDocument) ? (
                                <div className="btn-div">
                                  <img
                                    src={consentImageChangeOfNameDocumentThumbnail}
                                    alt="Consent Image Change of Name Document"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(consentImageChangeOfNameDocument) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_consent_image_change_of_name"
                              name="iv_consent_image_change_of_name"
                              type="file"
                              onChange={ConsentImageOfChangeOfNameDocuments}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              consentImageChangeOfNameDocument == '' ?
                                consentImageChangeOfNameDocumentError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                </>
              }
              {
                values.iv_application_type === 2 &&
                <>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>4- Other Documents</Typography>
                    <Box className='documentError'>{errors.iv_other_documents && touched.iv_other_documents ? (errors.iv_other_documents) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      otherDocuments ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setOtherDocuments("");
                                }}
                              />
                            }
                          >
                            {
                              otherDocumentsThumbnail &&
                                isImage(otherDocuments) ? (
                                <div className="btn-div">
                                  <img
                                    src={otherDocumentsThumbnail}
                                    alt="Other Documents"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(otherDocuments) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_other_documents"
                              name="iv_other_documents"
                              type="file"
                              onChange={OtherDocuments}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              otherDocuments == '' ?
                                otherDocumentsError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                </>
              } */}

            </Grid>
            <Grid container >
              <Grid item lg={12} sx={{ margin: '0px 50px 0px 25px' }}>
                {
                  error &&
                  <Error
                    error={error}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                }
              </Grid>
            </Grid>
            <Box sx={{ marginTop: '1%', textAlign: "right", marginRight: '2%', marginBottom: '2%' }}>
              <Button
                sx={{
                  borderRadius: 20
                }}
                variant="contained"
                component="label"
                className="submitBtn"
                type="submit"
                onClick={(e) => { console.log(errors); handleSubmit(e); }}
                disabled={isLoadingSpinner}
              >
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      </Grid >

      < Dialog
        open={changeOfNamePopUp}
        onClose={() => handleClose('CON')}
        className='dialog'
        fullWidth={true}
        maxWidth={'sm'}
        PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
      >
        <DialogTitle  >
          <Box className="backgroundAttached" >
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle"> Request Submitted</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p className="applicationSubmit">  Your Change of Name request is submitted successfully.</p>
            <p className="trackIdPara"> Your Application ID.</p>
            <p className="trackId"> {applicationID}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      < Dialog
        open={changeOfLoadPopUp}
        onClose={() => handleClose('COL')}
        className='dialog'
        fullWidth={true}
        maxWidth={'sm'}
        PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
      >
        <DialogTitle  >
          <Box className="backgroundAttached" >
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle"> Request Submitted</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p className="applicationSubmit">  Your Change of Load request is submitted successfully.</p>
            <p className="trackIdPara"> Your Application ID.</p>
            <p className="trackId"> {applicationID}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      < Dialog
        open={changeOfTariffPopUp}
        onClose={() => handleClose('COT')}
        className='dialog'
        fullWidth={true}
        maxWidth={'sm'}
        PaperProps={{ style: { width: '100%', borderRadius: 20 } }}
      >
        <DialogTitle  >
          <Box className="backgroundAttached" >
            <DoneIcon className="icon" />
          </Box>
          <Typography variant="h6" className="groupTitle"> Request Submitted</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <p className="applicationSubmit">  Your Change of Tariff request is submitted successfully.</p>
            <p className="trackIdPara"> Your Application ID.</p>
            <p className="trackId"> {applicationID}</p>
          </DialogContentText>
        </DialogContent>
      </Dialog >


      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  )

}

export default ChangeOfAttributesForm;